import React, { Component } from "react";
import { can } from "../../utils/permission";
import { resolveWarrantyStatus } from "../../utils/warranty";
import {
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  Select,
  DatePicker,
  alert,
  company,
  float,
  t,
  format_date,
  activeOptions,
  ActionIconButton,
  ACTION_ICONS,
  STICKY_ACTION_STYLE
} from "../../components/CustomComponent.js";
import GlobalSearchBox from "../../components/GlobalSearchBox.js";
import { getProfile } from "../../utils/localStorage";
import {
  WORK_REQUEST_UPLOAD_RULES,
  pickFilesByRule,
  compressImageFiles,
  formatText,
  formatFileSize,
  toMB,
} from "../../utils/fileUpload";

const IMAGE_RULE = WORK_REQUEST_UPLOAD_RULES.image;
const VIDEO_RULE = WORK_REQUEST_UPLOAD_RULES.video;

// dropdown ลูกค้า/ทรัพย์สิน: ข้อมูลเยอะเกินกว่าจะดึงมาทั้งตารางตอนเข้าหน้า
// จึงค้นจาก backend ทีละหน้าเมื่อผู้ใช้เปิดรายการ (searchCustomers / searchAssets)
const CUSTOMER_SEARCH_LIMIT = 20;
const ASSET_SEARCH_LIMIT = 20;

// ISS-003: หน้า Fast Call ให้กรอก "สรุปอาการที่ลูกค้าแจ้ง" ได้ไม่เกิน 20 ตัวอักษร

export default class WorkRequests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company_id: company?.id || "", // จาก Header ที่ให้มา
            filter_search: "",
            // ISS-030: "งานของฉัน" เป็นค่าเริ่มต้น และจำค่าที่ผู้ใช้เลือกไว้ข้ามการเข้าใช้งาน
            filter_scope: localStorage.getItem("cm-wr-scope") || "mine",
            tab: "pending", // เข้าหน้ามาให้อยู่แท็บ "รอดำเนินการ" ก่อน (all | pending | success | pending_approval | approved | rejected)
            page: 1,
            page_size: 10,
            count: 0,
            data: [],
            summary_count: {
                pending: 0,
                success: 0,
                pending_approval: 0,
                approved: 0,
                rejected: 0,
                all: 0,
            },

            // Options from API
            data_customer: [],
            data_asset: [],
            // โหมด remote ของ Select: จำคำค้นล่าสุดไว้กันยิงซ้ำ + ธงโหลดไว้โชว์ "กำลังค้นหา..."
            customer_search_keyword: null,
            customer_search_loading: false,
            asset_search_keyword: null,
            asset_search_customer_id: null,
            asset_search_loading: false,
            data_reject_reasons: [],
            data_service_types: [],
            data_priorities: [],
            data_categories: [],
            data_technicians: [],

            // Modals
            modal_approve: false,
            modal_fast_call: false,
            modal_reject: false,
            modal_create: false,
            view_mode: false,
            fast_call_view_mode: false,
            reject_view_mode: false,
            active_request: null,

            // Reject Form States
            reject_reason_id: "",
            reject_note: "",
            fast_call_technician: "",
            fast_call_date: "",
            fast_call_time: "",
            fast_call_duration: 0,
            fast_call_channel: "โทรศัพท์ตรง",
            fast_call_symptom: "",
            fast_call_guidance: "",
            fast_call_result: "visit",

            // Create/Update Form States
            uid: "",
            create_customer_id: "",
            create_asset_id: "",
            create_contact_name_1: "",
            create_contact_phone_1: "",
            create_contact_name_2: "",
            create_contact_phone_2: "",
            create_contact_email: "",
            create_category_id: "",
            create_service_type_id: "",
            create_problem_desc: "",
            create_priority_id: "",
            create_internal_note: "",
            create_channel: "call",
            text_priority_id: "",

            select_asset: null,

            // Upload Files
            images: [],
            videos: [],

            // Mock Data สำหรับส่วนที่ยังไม่มี API (เช่น ช่าง)
            technicians: [{ name: "Somchai T.", initials: "ST", bg: "#198754", status: "Available Now", statusColor: "success", distance: "5.2 km away", bestMatch: true, tags: [], hint: "" }],
            wo_type: "Corrective Maintenance",
            wo_priority: "Emergency",
            sla_template: "Emergency SLA (1hr/4hr)",
        };
    }

    async componentDidMount() {
        loading(true);
        await this.GetOptions();
        // ISS-001: เข้ามาจาก global search (?search=WR-xxxx) ให้เติมคำค้นแล้วกรองให้เลย
        const keyword = new URLSearchParams(window.location.search).get("search") || "";
        if (keyword) {
            await new Promise((resolve) => this.setState({ filter_search: keyword }, resolve));
            const url = new URL(window.location.href);
            url.searchParams.delete("search");
            window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        }
        await this.Get(1);
        loading(false);
    }

    // จำค่าที่เลือกไว้ใน localStorage เพื่อไม่ต้องกดใหม่ทุกครั้งที่เข้าหน้า (ISS-030)
    changeScope = (scope) => {
        localStorage.setItem("cm-wr-scope", scope);
        this.setState({ filter_scope: scope }, () => this.Get(1));
    };

    // ค้นด้วยคำค้น (Enter / ปุ่มค้นหา / เลือกจาก dropdown): ถ้าอยู่ "งานของฉัน" ให้สลับไป "ทั้งหมด" ก่อน
    // เพราะ dropdown แนะนำผลจากทุกใบ แต่ตาราง "งานของฉัน" กรองเฉพาะใบของฉัน - ค้นเจอแต่ตารางว่าง
    // ไม่บันทึกลง localStorage เพราะเป็นการสลับชั่วคราวเพื่อการค้นครั้งนี้ ไม่ใช่ค่าที่ผู้ใช้เลือกเอง
    searchWithScopeAll = (selectedTab) => {
        if (this.state.filter_search?.trim() && this.state.filter_scope === "mine") {
            this.setState({ filter_scope: "all" }, () => this.Get(1, selectedTab));
            return;
        }
        this.Get(1, selectedTab);
    };

    getCreateFormState = () => ({
        uid: "",
        create_customer_id: "",
        create_asset_id: "",
        create_contact_name_1: "",
        create_contact_phone_1: "",
        create_contact_name_2: "",
        create_contact_phone_2: "",
        create_contact_email: "",
        create_category_id: "",
        create_service_type_id: this.getDefaultServiceTypeId(),
        create_problem_desc: "",
        create_priority_id: "",
        create_internal_note: "",
        create_channel: "call",
        text_priority_id: "",
        select_asset: null,
        images: [],
        videos: [],
        view_mode: false,
        // ล้างผลค้นหาที่ค้างจากใบก่อน ไม่งั้นเปิด modal ใหม่จะยังเห็นตัวเลือกของใบเดิม
        data_customer: [],
        data_asset: [],
        customer_search_keyword: null,
        asset_search_keyword: null,
        asset_search_customer_id: null,
    });

    getFastCallFormState = () => {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        return {
            fast_call_technician: "",
            fast_call_date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
            fast_call_time: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
            fast_call_duration: 0,
            fast_call_channel: "โทรศัพท์ตรง",
            fast_call_symptom: "",
            fast_call_guidance: "",
            fast_call_result: "",
        };
    };

    getCurrentLang = () => localStorage.getItem("lang") || "TH";

    getCustomerDisplayName = (customer) => {
        const currentLang = this.getCurrentLang();

        if (currentLang === "EN") {
            return `${customer?.customer_code || ""} ${customer?.full_name_en || customer?.full_name_th || customer?.name || "-"}`;
        }

        return `${customer?.customer_code || ""} ${customer?.full_name_th || customer?.full_name_en || customer?.name || "-"}`;
    };

    getAssetDisplayName = (asset) => {
        return asset?.part_name || asset?.part?.name || asset?.asset_name || asset?.name || "-";
    };

    // ป้ายใน dropdown เลือกทรัพย์สิน: description ของ Item Master แล้วตามด้วย Serial No.
    // ถ้า item master ไม่ได้กรอก description ไว้ ใช้ชื่อสินค้าแทนเพื่อไม่ให้ตัวเลือกว่างเปล่า
    getAssetDescription = (asset) => {
        return asset?.part?.description || asset?.part_description || this.getAssetDisplayName(asset);
    };

    // บรรทัดระบุเครื่อง "part number : หมายเลขเครื่อง" ใช้ทั้งคอลัมน์ ลูกค้า/ทรัพย์สิน ในตาราง และ label ของ dropdown สินทรัพย์
    // มีอย่างใดอย่างหนึ่งก็แสดงเท่าที่มี ไม่มีทั้งคู่ค่อยถอยไปใช้ชื่อเครื่อง
    getAssetIdentityLine = (asset) => {
        const partNumber = asset?.part_number || asset?.part?.part_number || "";
        const serialNumber = asset?.serial_number || "";
        return [partNumber, serialNumber].filter(Boolean).join(" : ") || this.getAssetDisplayName(asset);
    };

    getAssetLocationName = (asset) => {
        return asset?.location_name || asset?.location?.name || asset?.location?.location_name || "-";
    };

    // วันหมดประกันลูกค้าที่ใช้แสดง/ตัดสินป้าย = รอบที่ครอบวันนี้ ถ้าไม่มีรอบไหนครอบ = รอบล่าสุดที่เริ่มไปแล้ว
    // (เช็ควันเริ่มรอบด้วย ไม่ใช่วันหมดที่ไกลสุด - ช่วงว่างก่อนถึงวันเริ่มรอบที่ต่อใหม่ = หมดประกัน) ดู utils/warranty.js
    getAssetWarrantyExpireDate = (asset) => resolveWarrantyStatus(asset, "customer").expireDate;

    // ป้ายสถานะประกันในกล่องข้อมูล Asset: เน้นด้วย pill สีเขียว (✓ ในประกัน) / สีแดง (⚠ หมดประกัน)
    // ใช้สีพื้นอ่อน + ตัวหนังสือเข้ม ให้ต่างจากพื้นฟ้าของกล่องชัดเจน ไม่มีวันหมดประกัน = ป้ายเทา "-"
    renderWarrantyBadge = (expireDate) => {
        const baseStyle = { fontSize: "12px", padding: "3px 10px", whiteSpace: "nowrap", verticalAlign: "middle" };
        if (!expireDate) {
            return (
                <span className="badge rounded-pill fw-bold" style={{ ...baseStyle, backgroundColor: "#E5E7EB", color: "#4B5563" }}>
                    -
                </span>
            );
        }
        const expired = this.isWarrantyExpired(expireDate);
        const until = `(${t("warranty_until")} ${format_date(expireDate, "dd/mm/yyyy", "th")})`;
        return (
            <span
                className="badge rounded-pill fw-bold"
                style={{
                    ...baseStyle,
                    backgroundColor: expired ? "#FEE2E2" : "#DCFCE7",
                    color: expired ? "#B91C1C" : "#15803D",
                    border: `1px solid ${expired ? "#FCA5A5" : "#86EFAC"}`,
                }}
            >
                <span className="icon me-1">{expired ? "\uf071" : "\uf00c"}</span>
                {expired ? t("out_of_warranty") : t("under_warranty")} {until}
            </span>
        );
    };

    isWarrantyExpired = (expireDate) => {
        const raw = String(expireDate || "").trim();
        if (!raw) return true;
        const parsed = new Date(raw.split("T")[0]);
        if (isNaN(parsed.getTime())) return true;
        parsed.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return parsed < today;
    };

    getReceivedMeta = (item) => {
        const receivedSource = item?.created_at || item?.receive_date || item?.received_at || item?.updated_at || "";
        if (!receivedSource) {
            return {
                receivedAgo: "-",
                receivedDate: "",
            };
        }

        const receivedDate = new Date(receivedSource);
        if (Number.isNaN(receivedDate.getTime())) {
            return {
                receivedAgo: "-",
                receivedDate: "",
            };
        }

        const now = new Date();
        const diffMs = Math.max(0, now.getTime() - receivedDate.getTime());
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        let receivedAgo = "-";
        if (diffDays > 0) {
            receivedAgo = `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
        } else if (diffHours > 0) {
            receivedAgo = `${diffHours} hr${diffHours > 1 ? "s" : ""} ago`;
        } else if (diffMinutes > 0) {
            receivedAgo = `${diffMinutes} min ago`;
        } else {
            receivedAgo = "Just now";
        }

        return {
            receivedAgo,
            receivedDate: String(receivedSource).split("T")[0],
        };
    };

    normalizeWorkRequestItem = (item) => {
        const normalizedAsset = item?.asset
            ? {
                  ...item.asset,
                  part_name: this.getAssetDisplayName(item.asset),
                  customer_warranty_expire_date: this.getAssetWarrantyExpireDate(item.asset),
                  location_name: this.getAssetLocationName(item.asset),
              }
            : null;
        const receivedMeta = this.getReceivedMeta(item);

        return {
            ...item,
            asset: normalizedAsset,
            ...receivedMeta,
        };
    };

    getFilteredAssetOptions = () => {
        const { data_asset, create_customer_id } = this.state;

        if (!create_customer_id) {
            return [];
        }

        // ไม่กรองด้วยลูกค้าซ้ำฝั่งนี้แล้ว - backend กรองมาให้ตั้งแต่ searchAssets (customer_id)
        // และ asset ที่ seed ไว้ตอนเปิดดูใบเก่าไม่มี customer ติดมาด้วย จะโดนกรองทิ้งทั้งที่ถูกตัวแล้ว
        return activeOptions(data_asset, this.state.create_asset_id);
    };

    // SLA ที่ต้องใช้กับลูกค้ารายนี้ - สถานะ hold บังคับเป็น priority ชื่อ Hold ไม่ใช่ค่าที่ผูกไว้กับลูกค้า
    HOLD_CUSTOMER_STATUSES = ["hold", "on hold", "ระงับ", "พักใช้งาน", "พัก"];

    resolveCustomerPriorityId = (customer) => {
        const customerPriorityId = customer?.priority?.uid || customer?.priority_id || "";
        const status = String(customer?.customer_status || "").trim().toLowerCase();
        if (!this.HOLD_CUSTOMER_STATUSES.includes(status)) return customerPriorityId;

        const holdPriority = this.state.data_priorities.find((priority) =>
            ["hold"].includes(String(priority?.name_en || "").trim().toLowerCase()) ||
            ["hold"].includes(String(priority?.name_th || "").trim().toLowerCase()),
        );
        return holdPriority?.uid || customerPriorityId;
    };

    getPriorityDescription = (priorityItem) => {
        if (!priorityItem) {
            return "";
        }

        return `${priorityItem.name_th} - ${t("must_respond_within")} ${priorityItem.sla_response_time_start} - ${priorityItem.sla_response_time_end} ${priorityItem.sla_response_time_start_unit}`;
    };

    // service type ที่ fix ไว้ใน database ให้ใช้เป็นค่าเริ่มต้นเมื่อ category ไม่มี service type ผูกไว้
    getDefaultServiceTypeId = () => {
        const defaultServiceType = this.state.data_service_types.find((item) => item?.name_en === "Corrective Maintenance");

        return defaultServiceType?.uid || "";
    };

    getTechnicianDisplayName = (technician) => {
        let nickname_th = technician?.nickname_th ? ` (${technician?.nickname_th})` : "";
        let nickname_en = technician?.nickname_en ? ` (${technician?.nickname_en})` : "";
        return `${
            [technician?.first_name_th, technician?.last_name_th, nickname_th].filter(Boolean).join(" ") ||
            [technician?.first_name_en, technician?.last_name_en, nickname_en].filter(Boolean).join(" ") || "-"
        }`;
    };

    // -----------------------------------
    // API Methods
    // -----------------------------------

    // ดึงข้อมูล Master Data สำหรับ Dropdown
    // ลูกค้า/ทรัพย์สินไม่ได้ดึงตรงนี้แล้ว - ค้นจาก backend ตอนผู้ใช้เปิด dropdown (searchCustomers / searchAssets)
    GetOptions = async () => {
        let [res_reject, res_service, res_priority, res_category, res_technicians] = await Promise.all([
            GET("admin/work-requisition/reject-reasons", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/service-types", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/priorities", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/categories", { page: 0, page_size: 10000 }),
            GET("admin/technicians", { page: 0, page_size: 10000 }),
        ]);

        this.setState({
            data_reject_reasons: res_reject?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_service_types: res_service?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_priorities: res_priority?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_categories: res_category?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_technicians: res_technicians?.data || [],
        });
    };

    // แปลง record -> option ของ Select (ใช้ทั้งตอนค้นหา และตอน seed ค่าที่เลือกไว้ของใบที่เปิดดู)
    toCustomerOption = (e) => ({ ...e, group: undefined, value: e.uid, label: this.getCustomerDisplayName(e) });

    toAssetOption = (e) => ({
        ...e,
        part_name: this.getAssetDisplayName(e),
        customer_warranty_expire_date: this.getAssetWarrantyExpireDate(e),
        location_name: this.getAssetLocationName(e),
        value: e.uid,
        label: this.getAssetIdentityLine(e) || "-",
    });

    // dropdown ลูกค้า: ค้นจาก backend ทีละหน้า เฉพาะที่แสดงใน label (รหัส + ชื่อ)
    // ไม่ค้นเบอร์/อีเมล/เลขผู้เสียภาษี เพราะผู้ใช้จะเห็นรายการที่ตรงแต่ดูไม่ออกว่าตรงตรงไหน
    searchCustomers = async (keyword = "") => {
        const keySearch = String(keyword || "").trim();

        // คำค้นเดิมและมีผลอยู่แล้ว = ไม่ต้องยิงซ้ำ (เปิด-ปิด dropdown ไปมาไม่ควรยิงทุกครั้ง)
        if (keySearch === this.state.customer_search_keyword && this.state.data_customer.length > 0) return;

        this.setState({ customer_search_keyword: keySearch, customer_search_loading: true });

        // ไม่ส่ง is_active มา เพราะรายการที่ปิดใช้งานแต่ถูกเลือกไว้ต้องยังแสดงได้ (activeOptions คัดตอน render)
        const result = await GET("admin/customers", {
            page: 1,
            page_size: CUSTOMER_SEARCH_LIMIT,
            data_search: keySearch,
            search_scope: "display",
        });

        // ผู้ใช้พิมพ์ต่อไปแล้วระหว่างรอ = ผลชุดนี้ตกรุ่น ทิ้งไปเลย ไม่งั้นรายการจะเด้งกลับไปเป็นของคำค้นเก่า
        if (this.state.customer_search_keyword !== keySearch) return;

        this.setState({
            data_customer: (result?.data || []).map(this.toCustomerOption),
            customer_search_loading: false,
        });
    };

    // dropdown ทรัพย์สิน: ผูกกับลูกค้าที่เลือกไว้ -> ให้ backend กรองด้วย customer_id
    // cache key ต้องรวม customer_id ด้วย ไม่งั้นเปลี่ยนลูกค้าแล้วคำค้นเดิมจะไม่ยิงใหม่ (รายการเก่าค้าง)
    searchAssets = async (keyword = "") => {
        const keySearch = String(keyword || "").trim();
        const customerId = this.state.create_customer_id;

        if (!customerId) {
            this.setState({ data_asset: [], asset_search_keyword: null, asset_search_customer_id: null });
            return;
        }

        if (
            keySearch === this.state.asset_search_keyword &&
            customerId === this.state.asset_search_customer_id &&
            this.state.data_asset.length > 0
        )
            return;

        this.setState({ asset_search_keyword: keySearch, asset_search_customer_id: customerId, asset_search_loading: true });

        // lite=true: ได้ field snapshot + customer + warranty ครบสำหรับ dropdown โดยไม่ join หนัก
        const result = await GET("admin/assets", {
            page: 1,
            page_size: ASSET_SEARCH_LIMIT,
            lite: "true",
            customer_id: customerId,
            data_search: keySearch,
        });

        // พิมพ์ต่อ หรือเปลี่ยนลูกค้าไปแล้วระหว่างรอ = ผลชุดนี้ตกรุ่น ทิ้งไปเลย
        if (this.state.asset_search_keyword !== keySearch || this.state.asset_search_customer_id !== customerId) return;

        this.setState({
            data_asset: (result?.data || []).map(this.toAssetOption),
            asset_search_loading: false,
        });
    };

    // ดึง asset ตัวเต็มใบเดียวตาม uid - response ของ work-requisition ไม่มี location_name / warranty / part.description
    fetchAssetOption = async (uid, fallback = null) => {
        const result = uid ? await GET("admin/assets", { uid }) : null;
        const source = result?.data || fallback;
        return source ? this.toAssetOption(source) : null;
    };

    Get = async (page, selectedTab = this.state.tab) => {
        // ช่างมีแค่ 3 แท็บ ถ้าหลุดมาแท็บที่ซ่อนอยู่ให้ดีดกลับไป "รอดำเนินการ"
        if (this.isTechnicianUser() && !this.technicianTabKeys.includes(selectedTab)) {
            selectedTab = "pending";
        }
        loading(true);
        const status = selectedTab === "all" ? "" : selectedTab;
        let [result, summaryResult] = await Promise.all([
            GET("admin/work-requisitions", {
                page_size: this.state.page_size,
                page: page,
                data_search: this.state.filter_search || "",
                type: "",
                status,
                scope: this.state.filter_scope,
            }),
            // summary=true: backend นับตามสถานะด้วย GROUP BY ไม่ต้องดึงทุกแถวมานับเอง
            GET("admin/work-requisitions", {
                summary: "true",
                data_search: this.state.filter_search || "",
                type: "",
                scope: this.state.filter_scope,
            }),
        ]);

        if (result?.status) {
            const summary_count = {
                pending: 0, success: 0, pending_approval: 0, approved: 0, rejected: 0, all: 0,
                ...(summaryResult?.status && summaryResult.data ? summaryResult.data : {}),
            };

            this.setState({
                data: (result.data || []).map((item) => this.normalizeWorkRequestItem(item)),
                count: result.pagination?.count || 0,
                page,
                tab: selectedTab,
                summary_count,
            });
        }
        loading(false);
    };

    CreateUpdate = async () => {
        const {
            uid,
            company_id,
            create_customer_id,
            create_asset_id,
            create_contact_name_1,
            create_contact_phone_1,
            create_contact_name_2,
            create_contact_phone_2,
            create_contact_email,
            create_channel,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_internal_note,
            images,
            videos, // สำหรับจัดการไฟล์ถ้า API รองรับ Multipart
        } = this.state;

        // ตรวจครบทุกช่องที่ติดดาวแดง (*) แล้วบอกชื่อช่องที่ยังขาดในข้อความเดียว
        const missing = [];
        if (!create_customer_id) missing.push(t("customer"));
        if (!create_asset_id) missing.push(t("asset"));
        if (!create_category_id) missing.push(t("req_category"));
        if (!create_service_type_id) missing.push(t("service_type"));
        if (!create_problem_desc?.trim()) missing.push(t("problem_description"));
        if (!create_priority_id) missing.push(t("priority"));

        if (missing.length > 0) {
            alert("", "warning", t("warning"), `${t("required_fields_missing")}: ${missing.join(", ")}`);
            return;
        }

        if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
            loading(true);

            // อัปโหลดไฟล์ทีละไฟล์ (presigned URL ยิงตรงเข้า S3 -> fallback base64) เพื่อนำ path กลับมาใส่ใน body
            // ก่อนบันทึกข้อมูล work-request ทั้งหมด
            const image_attachments = await this.uploadAttachments(images, "work-requisitions/images", "image");
            const video_attachments = await this.uploadAttachments(videos, "work-requisitions/videos", "video");

            if (image_attachments === null || video_attachments === null) {
                // มีไฟล์อัปโหลดไม่สำเร็จ (POST แสดง alert แล้ว) ยกเลิกการบันทึก
                loading(false);
                return;
            }

            const attachments = [...image_attachments, ...video_attachments];

            let body = {
                company_id: company_id,
                customer_id: create_customer_id,
                asset_id: create_asset_id,
                contact_name_1: create_contact_name_1,
                contact_phone_1: create_contact_phone_1,
                contact_name_2: create_contact_name_2,
                contact_phone_2: create_contact_phone_2,
                contact_email: create_contact_email,
                channel: create_channel,
                work_requisition_categories_id: create_category_id,
                work_requisition_service_types_id: create_service_type_id,
                problem_description: create_problem_desc,
                work_requisition_priorities_id: create_priority_id,
                work_requisition_reject_reasons_id: "",
                reject_description: "",
                status: "pending", // Default status
                internal_remark: create_internal_note,
                attachments: attachments,
                is_active: true,
            };

            let result = !uid ? await POST("admin/work-requisitions", body) : await PUT("admin/work-requisitions/" + uid, body);

            if (result?.status === true) {
                alert("#", "success");
                this.setState({ modal_create: false, ...this.getCreateFormState() });
                this.Get(this.state.page);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };

    SubmitApprove = async () => {
        const { active_request, company_id } = this.state;

        if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
            loading(true);
            let body = {
                company_id: company_id,
                status: "approved",
                is_active: true,
                // ใส่ฟิลด์อื่นๆ เดิมเข้าไปด้วยหาก API บังคับ Require
            };

            let result = await PUT("admin/work-requisitions/" + active_request.uid, body);
            if (result?.status) {
                alert("#", "success");
                this.setState({ modal_reject: false });
                this.Get(this.state.page);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };
    SubmitReject = async () => {
        const { active_request, reject_reason_id, reject_note, company_id } = this.state;

        if (!reject_reason_id) {
            alert("", "warning", t("warning"), t("reject_reason_required"));
            return;
        }

        loading(true);
        let body = {
            company_id: company_id,
            work_requisition_reject_reasons_id: reject_reason_id,
            reject_description: reject_note,
            status: "rejected",
            is_active: true,
            // ใส่ฟิลด์อื่นๆ เดิมเข้าไปด้วยหาก API บังคับ Require
        };

        let result = await PUT("admin/work-requisitions/" + active_request.uid, body);
        if (result?.status) {
            alert("#", "success");
            this.setState({ modal_reject: false });
            this.Get(this.state.page);
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }
        loading(false);
    };

    Delete = async (id) => {
        if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
            loading(true);
            let result = await DELETE("admin/work-requisitions/" + id, null);
            if (result?.status) {
                alert("#", "success");
                this.Get(1);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };

    componentWillUnmount() {
        // คืนหน่วยความจำ object URL ที่สร้างไว้สำหรับ preview
        [...(this.state.images || []), ...(this.state.videos || [])].forEach((item) => {
            if (item?.url && item.url.startsWith("blob:")) {
                URL.revokeObjectURL(item.url);
            }
        });
    }

    // -----------------------------------
    // File Helpers
    // -----------------------------------
    // แปลง File เป็น object สำหรับ preview พร้อม url ชั่วคราว
    mapFilesToItems = (files) =>
        Array.from(files).map((file) => ({
            file,
            name: file.name,
            size: file.size,
            type: file.type,
            url: URL.createObjectURL(file),
        }));

    // รวมเหตุผลที่ไฟล์ถูกปฏิเสธเป็นข้อความเดียว แล้วแจ้งครั้งเดียว
    // (alert() ของโปรเจกต์จะ "ทิ้ง" ข้อความที่ยิงซ้อนขณะมี modal เปิดอยู่)
    notifyRejectedFiles = ({ wrongType, tooBig, overLimit, rule }, fileType) => {
        const messages = [];

        if (wrongType.length > 0) {
            messages.push(`${t("file_type_not_allowed")}: ${wrongType.join(", ")}`);
        }
        if (tooBig.length > 0) {
            messages.push(`${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${tooBig.join(", ")}`);
        }
        if (overLimit > 0) {
            const key = fileType === "video" ? "max_videos_reached" : "max_images_reached";
            messages.push(formatText(t(key), { count: rule.maxFiles, excess: overLimit }));
        }

        if (messages.length > 0) {
            alert("", "warning", t("warning"), messages.join(" · "));
        }
    };

    // เพิ่มไฟล์เข้า state ตามกติกา: ชนิดไฟล์ -> ขนาดต่อไฟล์ -> จำนวนสูงสุด -> บีบอัดรูป
    // fileType: "image" | "video"
    addFiles = async (fileList, fileType) => {
        const stateKey = fileType === "video" ? "videos" : "images";
        const current = this.state[stateKey] || [];

        const result = pickFilesByRule(fileList, fileType, current.length);
        this.notifyRejectedFiles(result, fileType);
        if (result.accepted.length === 0) return;

        // บีบอัดรูปก่อนเก็บเข้า state เพื่อลดพื้นที่จัดเก็บบน S3 (วิดีโอบีบฝั่ง browser ไม่ได้ ใช้ตามเดิม)
        let files = result.accepted;
        if (fileType === "image") {
            loading(true);
            try {
                files = await compressImageFiles(result.accepted);
            } finally {
                loading(false);
            }
        }

        const newItems = this.mapFilesToItems(files);
        this.setState((prev) => ({ [stateKey]: [...prev[stateKey], ...newItems] }));
    };

    // อัปโหลดไฟล์ทีละไฟล์ (presigned URL -> fallback base64) แล้วคืน array ของ attachment object
    // { uid?, file_path, file_name, file_type, mime_type, file_size }
    // คืนค่า null หากมีไฟล์ใดอัปโหลดไม่สำเร็จ
    uploadAttachments = async (items, folder, fileType) => {
        const uploaded = [];

        for (const item of items || []) {
            // ไฟล์ที่อัปโหลดแล้ว (กรณีดู/แก้ไข) ส่ง meta เดิมกลับไป ไม่ต้องอัปโหลดซ้ำ
            if (!item?.file && typeof item?.url === "string" && item.url.includes("://")) {
                uploaded.push({
                    uid: item.uid,
                    file_path: item.url,
                    file_name: item.name || null,
                    file_type: item.file_type || fileType,
                    mime_type: item.mime_type || null,
                    file_size: item.file_size ?? null,
                });
                continue;
            }

            // backstop: กันไฟล์ใหญ่เกินหลุดมาถึงขั้นอัปโหลด
            const rule = WORK_REQUEST_UPLOAD_RULES[fileType] || WORK_REQUEST_UPLOAD_RULES.image;
            if (item?.file && item.file.size > rule.maxSize) {
                alert("", "warning", t("warning"), `${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${item?.name || ""}`);
                return null;
            }

            const res = await UPLOAD(item.file, { folder });

            if (res?.status === true && res?.data?.file_path) {
                uploaded.push({
                    file_path: res.data.file_path,
                    file_name: item.name || res.data.file_name || null,
                    file_type: fileType,
                    mime_type: res.data.mime_type || item.type || null,
                    file_size: res.data.file_size ?? item.size ?? null,
                });
            } else {
                alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
                return null;
            }
        }

        return uploaded;
    };

    // -----------------------------------
    // Drag and Drop Handlers
    // -----------------------------------
    handleDragOver = (e) => {
        e.preventDefault();
    };

    handleImageDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.addFiles(files, "image");
        }
    };

    handleVideoDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.addFiles(files, "video");
        }
    };

    removeImage = async (index) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let imgs = [...prevState.images];
            const [removed] = imgs.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            return { images: imgs };
        });
    };

    removeVideo = async (index) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let vids = [...prevState.videos];
            const [removed] = vids.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            return { videos: vids };
        });
    };

    // -----------------------------------
    // Helpers
    // -----------------------------------
    getPriorityStyle = (priorityName) => {
        const p = String(priorityName).toUpperCase();
        if (p.includes("EMERGENCY")) return { backgroundColor: "#dc3545", color: "#fff" };
        if (p.includes("HIGH")) return { backgroundColor: "#fd7e14", color: "#fff" };
        if (p.includes("MEDIUM")) return { backgroundColor: "#ffc107", color: "#fff" };
        return { backgroundColor: "#0d6efd", color: "#fff" };
    };

    getCategoryClass = (categoryName) => {
        const c = String(categoryName);
        if (c.includes("Corrective")) return "bg-secondary-light text-secondary";
        if (c.includes("Preventive")) return "bg-success-light text-success";
        return "bg-primary-light text-primary";
    };

    openViewModal = (request) => {
        this.openDetailModal(request);
    };

    // เปิด modal เดียวกับ create แต่เป็นโหมดดูอย่างเดียว (read-only) พร้อม preview ไฟล์แนบ
    openDetailModal = async (request) => {
        loading(true);
        const result = await GET("admin/work-requisitions", { uid: request?.uid });

        if (result?.status !== true || !result?.data) {
            loading(false);
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const d = result.data;
        const attachments = Array.isArray(d.attachments) ? d.attachments : [];
        const toItem = (a) => ({
            uid: a.uid,
            name: a.file_name || "",
            url: a.file_path,
            file_type: a.file_type,
            mime_type: a.mime_type,
            file_size: a.file_size,
            is_uploaded: true,
        });

        const matchedPriority = this.state.data_priorities.find((p) => p.uid === d.priority?.uid);
        // ดึง asset ตัวเต็มมาใบเดียว (เมื่อก่อนอาศัย data_asset ที่โหลดมาทั้งตาราง ซึ่งไม่มีแล้ว)
        const selectedAsset = await this.fetchAssetOption(d.asset?.uid, d.asset);
        loading(false);

        this.setState({
            modal_create: true,
            view_mode: true,
            uid: d.uid,
            active_request: d,
            // seed option ของค่าที่เลือกไว้ ไม่งั้นสองช่องนี้จะว่าง เพราะโหมด remote ไม่มีรายการทั้งตารางให้หา label แล้ว
            data_customer: d.customer ? [this.toCustomerOption(d.customer)] : [],
            data_asset: selectedAsset ? [selectedAsset] : [],
            customer_search_keyword: null,
            asset_search_keyword: null,
            asset_search_customer_id: null,
            create_customer_id: d.customer?.uid || "",
            create_asset_id: d.asset?.uid || "",
            select_asset: selectedAsset,
            create_contact_name_1: d.contact_name_1 || "",
            create_contact_phone_1: d.contact_phone_1 || "",
            create_contact_name_2: d.contact_name_2 || "",
            create_contact_phone_2: d.contact_phone_2 || "",
            create_contact_email: d.contact_email || "",
            create_category_id: d.category?.uid || "",
            create_service_type_id: d.service_type?.uid || this.getDefaultServiceTypeId(),
            create_problem_desc: d.problem_description || "",
            create_priority_id: d.priority?.uid || "",
            text_priority_id: this.getPriorityDescription(matchedPriority),
            create_internal_note: d.internal_remark || "",
            create_channel: d.channel || "call",
            images: attachments.filter((a) => a.file_type === "image").map(toItem),
            videos: attachments.filter((a) => a.file_type === "video").map(toItem),
        });
    };
    // ช่างที่เข้าเว็บแอดมิน: อนุมัติ/ปฏิเสธใบแจ้งงานไม่ได้ และ Fast Call ต้องเป็นตัวเองเป็นคนโทรเสมอ (backend กันไว้อีกชั้น)
    isTechnicianUser = () => getProfile()?.user_type === "technician";

    // เวลาสิ้นสุดการโทร = เริ่ม + นาที (แสดงผลอย่างเดียว ไม่เข้า payload)
    getFastCallEnd = () => {
        const { fast_call_date, fast_call_time, fast_call_duration } = this.state;
        const minutes = Number(fast_call_duration) || 0;
        const dm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(fast_call_date || "");
        const tm = /^(\d{2}):(\d{2})$/.exec(fast_call_time || "");
        if (!minutes || !dm || !tm) return null;
        const pad = (n) => String(n).padStart(2, "0");
        const start = new Date(Number(dm[1]), Number(dm[2]) - 1, Number(dm[3]), Number(tm[1]), Number(tm[2]));
        const end = new Date(start.getTime() + minutes * 60000);
        const nextDay = end.toDateString() !== start.toDateString();
        return {
            start: `${pad(start.getHours())}:${pad(start.getMinutes())}`,
            time: `${pad(end.getHours())}:${pad(end.getMinutes())}`,
            nextDay,
            date: `${pad(end.getDate())}/${pad(end.getMonth() + 1)}/${end.getFullYear() + 543}`,
        };
    };

    // รายการแท็บทั้งหมด (key ต้องตรงกับ status ที่ส่งให้ backend และ key ใน summary_count)
    tabConfig = [
        { key: "all", label: "all_requests", badgeClass: "bg-danger", badgeStyle: undefined },
        { key: "pending", label: "pending", badgeClass: "text-dark", badgeStyle: { backgroundColor: "#FFE58F" } },
        { key: "success", label: "success", badgeClass: "text-white", badgeStyle: { backgroundColor: "#22C55E" } },
        { key: "pending_approval", label: "waiting_approval", badgeClass: "text-white", badgeStyle: { backgroundColor: "#8B5CF6" } },
        { key: "approved", label: "approved", badgeClass: "fw-bold border", badgeStyle: { backgroundColor: "#BFDBFE", color: "#1D4ED8", borderColor: "#60A5FA" } },
        { key: "rejected", label: "rejected", badgeClass: "text-white", badgeStyle: { backgroundColor: "#9CA3AF" } },
    ];

    // ช่างเห็นแค่ 3 แท็บ: รอดำเนินการ / สำเร็จ / ปฏิเสธ
    technicianTabKeys = ["pending", "success", "rejected"];

    getVisibleTabs = () => {
        if (!this.isTechnicianUser()) return this.tabConfig;
        return this.tabConfig.filter((item) => this.technicianTabKeys.includes(item.key));
    };

    // uid ของช่างที่ผูกกับบัญชีที่ login อยู่ (technician.user_id = uid ของ user) ใช้ตั้ง "ช่างที่โทร" ให้ช่างอัตโนมัติ
    getMyTechnicianUid = () => {
        const profileUid = getProfile()?.uid;
        if (!profileUid) return "";
        return (this.state.data_technicians || []).find((technician) => technician.user_id === profileUid)?.uid || "";
    };

    openFastCallModal = (request) => {
        const defaultTechnicianId = this.isTechnicianUser() ? this.getMyTechnicianUid() : "";
        if (this.isTechnicianUser() && !defaultTechnicianId) {
            alert("", "warning", t("warning"), t("no_technicians_found"));
            return;
        }
        this.setState({
            modal_fast_call: true,
            fast_call_view_mode: false,
            active_request: request,
            ...this.getFastCallFormState(),
            fast_call_technician: defaultTechnicianId,
        });
    };

    openViewFastCallModal = async (request) => {
        loading(true);
        const result = await GET("admin/work-requisitions", { uid: request?.uid });
        loading(false);

        if (result?.status !== true || !result?.data) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const requestDetail = result.data;
        const callData = requestDetail?.fast_call || requestDetail?.call || requestDetail?.work_requisition_call || requestDetail?.latest_call;

        if (!callData) {
            alert("", "warning", t("warning"), t("no_data_found"));
            return;
        }

        const normalizedCallTime = String(callData?.call_time || "").replace(" ", "T").slice(0, 16);

        this.setState({
            modal_fast_call: true,
            fast_call_view_mode: true,
            active_request: requestDetail,
            fast_call_technician: callData?.technician_id || callData?.technician?.uid || "",
            fast_call_date: normalizedCallTime.slice(0, 10),
            fast_call_time: normalizedCallTime.slice(11, 16),
            fast_call_duration: callData?.call_duration || 0,
            fast_call_channel: callData?.call_channel || "โทรศัพท์ตรง",
            fast_call_symptom: callData?.detail_from_customer || "",
            fast_call_guidance: callData?.detail_solution || "",
            fast_call_result: callData?.status === "success" ? "closed" : "visit",
        });
    };
    openApproveModal = (request) => {
        this.setState(
            {
                active_request: request,
            },
            () => {
                this.SubmitApprove();
            }
        );
        //     const { data_priorities } = this.state;
        //     let i = data_priorities.find(e=>e.uid === request.priority?.uid);
        //     this.setState({
        //       modal_approve: true,
        //       active_request: request,
        //       create_category_id: request.category?.uid,
        //       create_service_type_id: request.service_type?.uid,
        //       create_priority_id: request.priority?.uid,
        //       text_priority_id: `${i.name_th} - ต้องตอบสนองภายใน ${i.sla_response_time_start} - ${i.sla_response_time_end} ${i.sla_response_time_start_unit}`
        //     });
    };

    getStatusBadgeClass = (status) => {
        const statusKey = (status || "").toLowerCase();

        if (statusKey === "pending") {
            return "bg-warning-light text-warning border border-warning";
        }
        if (statusKey === "pending_approval") {
            return "";
        }
        if (statusKey === "approved") {
            return "bg-info-light text-info border border-info";
        }
        if (statusKey === "success") {
            return "bg-success-light text-success border border-success";
        }
        if (statusKey === "cancel" || statusKey === "cancelled" || statusKey === "rejected") {
            return "bg-secondary-light text-secondary border border-secondary";
        }

        return "bg-light text-dark border";
    };

    openRejectModal = (request) => {
        this.setState({
            modal_reject: true,
            reject_view_mode: false,
            active_request: request,
            reject_reason_id: "",
            reject_note: "",
        });
    };

    openWorkOrderPage = (request) => {
        const workOrderNumber = request?.work_order?.wo_number || "";

        if (!workOrderNumber) {
            alert("", "warning", t("warning"), t("no_data_found"));
            return;
        }

        const queryParams = new URLSearchParams();
        queryParams.set("search", workOrderNumber);

        window.location.href = `/ad/work-orders?${queryParams.toString()}`;
    };

    viewRejectReason = (request) => {
        const rejectReasonId =
            request?.reject_reason?.uid ||
            request?.work_requisition_reject_reason?.uid ||
            request?.work_requisition_reject_reasons_id ||
            "";
        const rejectDescription = request?.reject_description || request?.reject_note || "";

        this.setState({
            modal_reject: true,
            reject_view_mode: true,
            active_request: request,
            reject_reason_id: rejectReasonId,
            reject_note: rejectDescription,
        });
    };

    openCreateModal = () => {
        this.setState({
            modal_create: true,
            ...this.getCreateFormState(),
        });
    };

    submitFastCall = async () => {
        const {
            company_id,
            active_request,
            fast_call_technician,
            fast_call_date,
            fast_call_time,
            fast_call_duration,
            fast_call_channel,
            fast_call_symptom,
            fast_call_guidance,
            fast_call_result,
            page,
        } = this.state;

        if (!fast_call_result) {
            alert("", "warning", t("warning"), t("call_result_required"));
            return;
        }

        if (!fast_call_technician || !active_request?.uid || !fast_call_date || !fast_call_time || fast_call_guidance === "") {
            alert("", "warning", t("warning"), t("required_fields"));
            return;
        }

        if (fast_call_guidance.trim().length < 20) {
            alert("", "warning", t("warning"), t("validate_solution_guidance_min_length"));
            return;
        }

        if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) {
            return;
        }

        loading(true);

        const body = {
            company_id: company_id,
            wr_id: active_request.uid,
            technician_id: fast_call_technician,
            call_time: fast_call_date && fast_call_time ? `${fast_call_date} ${fast_call_time}` : "",
            call_duration: Number(fast_call_duration),
            call_channel: fast_call_channel,
            detail_from_customer: fast_call_symptom,
            detail_solution: fast_call_guidance,
            status: fast_call_result === "closed" ? "success" : "pending_approval",
            is_active: true,
        };

        const result = await POST("admin/work-requisition/calls", body);

        if (result?.status === true) {
            this.setState({
                modal_fast_call: false,
                active_request: null,
                ...this.getFastCallFormState(),
            });
            await this.Get(page);
            await alert("#", "success");
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }

        loading(false);
    };

    render() {
        const {
            data,
            count,
            filter_search,
            tab,
            modal_approve,
            modal_fast_call,
            fast_call_view_mode,
            active_request,
            technicians,
            wo_type,
            wo_priority,
            sla_template,
            modal_reject,
            reject_view_mode,
            reject_reason_id,
            reject_note,
            fast_call_technician,
            fast_call_date,
            fast_call_time,
            fast_call_duration,
            fast_call_channel,
            fast_call_symptom,
            fast_call_guidance,
            fast_call_result,
            select_asset,
            modal_create,
            view_mode,
            create_customer_id,
            create_asset_id,
            create_contact_name_1,
            create_contact_phone_1,
            create_contact_name_2,
            create_contact_phone_2,
            create_contact_email,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_internal_note,
            images,
            videos,
            data_categories,
            data_priorities,
            data_reject_reasons,
            data_service_types,
            data_technicians,
            data_customer,
            customer_search_loading,
            asset_search_loading,
            text_priority_id,
            summary_count,
        } = this.state;

        const fastCallTechnicianOptions =
            Array.isArray(data_technicians) && data_technicians.length > 0
                ? activeOptions(
                      data_technicians.map((technician) => ({
                          is_active: technician.is_active,
                          value: technician.uid,
                          label: this.getTechnicianDisplayName(technician),
                      })),
                      this.state.fast_call_technician
                  )
                : [];
        const filteredAssetOptions = this.getFilteredAssetOptions();

        return (
            <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
                <NavbarAdmin />
                <div className="body p-4 mt-3">
                    {/* Header Section */}
                    <div className="mb-4">
                        <h3 className="fw-bold mb-1">{t("work_requests")}</h3>
                        <div className="text-secondary">{t("manage_incoming_service_requests")}</div>
                    </div>

                    {/* Top Filter Toolbar */}
                    <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div className="d-flex flex-wrap gap-2 flex-grow-1">
                                {/* ค้นหาเฉพาะใบแจ้งงานในเมนูนี้ (ครอบคลุมเลขที่ / ลูกค้า / ทรัพย์สิน / S-N / part master / ผู้ติดต่อ / หมวด ฯลฯ)
                                    Enter = กรองตาราง, เลือกจาก dropdown = เติมเลขที่แล้วกรองบนแท็บ "ทั้งหมด" เพราะใบที่เลือกอาจไม่อยู่แท็บปัจจุบัน
                                    ทั้งสองทางสลับ "งานของฉัน" -> "ทั้งหมด" ให้เอง (searchWithScopeAll) */}
                                <GlobalSearchBox
                                    scope="work_requisition"
                                    value={filter_search}
                                    onChange={(value) => this.setState({ filter_search: value })}
                                    onEnter={() => this.searchWithScopeAll()}
                                    onSelect={() => this.searchWithScopeAll("all")}
                                    placeholder={t("search_work_requests_placeholder")}
                                />
                                {/* ISS-030: สลับดูเฉพาะงานของฉัน / ทั้งหมด (ค่าเริ่มต้น = งานของฉัน) */}
                                {/* สไตล์ pill ชุดเดียวกับแท็บสลับมุมมอง (รายการ/คัมบังบอร์ด/ปฏิทิน)
                                    ใช้พื้น bg-light เพราะกล่องฟิลเตอร์นี้เป็นพื้นขาว ถ้าใช้พื้นขาวด้วยจะกลืนจนไม่เห็นกรอบ */}
                                <div className="btn-group bg-light p-1 rounded-3 border" role="group">
                                    {[
                                        { key: "mine", label: t("scope_mine"), icon: "\uf007" },
                                        { key: "all", label: t("scope_all"), icon: "\uf0c9" },
                                    ].map((option) => (
                                        <button
                                            key={option.key}
                                            type="button"
                                            className={`btn btn-sm rounded-2 px-3 fw-bold text-nowrap d-flex align-items-center border-0 ${
                                                this.state.filter_scope === option.key ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                            }`}
                                            onClick={() => this.changeScope(option.key)}
                                        >
                                            <span className="icon me-2">{option.icon}</span> {option.label}
                                        </button>
                                    ))}
                                </div>

                                <div className="d-flex gap-2">
                                    <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.searchWithScopeAll()}>
                                        {t("filter")}
                                    </button>
                                    <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}>
                                        {t("clear_all")}
                                    </button>
                                </div>
                                {/* Filters */}
                            </div>
                            <div className="d-flex gap-2">
                                {can("wr.create") && (
                                  <button className="btn btn-primary px-3 fw-bold rounded-3 shadow-sm" onClick={this.openCreateModal}>
                                      <span className="me-2">+</span>
                                      {t("create_request")}
                                  </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Tabs Section */}
                    {/* ช่างเห็นเฉพาะ รอดำเนินการ / สำเร็จ / ปฏิเสธ ส่วน role อื่นเห็นครบทุกแท็บ */}
                    <div className="d-flex border-bottom mb-3 px-2 text-14">
                        {this.getVisibleTabs().map((item) => (
                            <div
                                key={item.key}
                                className={`py-3 px-3 ${tab === item.key ? "fw-bold text-primary" : "text-secondary"} pointer`}
                                style={{ borderBottom: tab === item.key ? "3px #1976D2 solid" : "" }}
                                onClick={() => {
                                    this.Get(1, item.key);
                                }}
                            >
                                {t(item.label)}{" "}
                                <span className={`badge rounded-pill ms-1 px-2 ${item.badgeClass}`} style={item.badgeStyle}>
                                    {summary_count[item.key]}
                                </span>
                            </div>
                        ))}
                    </div>

                    {/* Table List Section */}
                    <div className="bg-white rounded-4 shadow-sm pb-2">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0" style={{ minWidth: "1800px" }}>
                                <thead>
                                    <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase">
                                        {/* <th className="px-3 pb-1 wpx-40">
                                            <input type="checkbox" className="form-check-input" />
                                        </th> */}
                                        <th className="py-3 border-0 wpx-150">{t("request_id")}</th>
                                        <th className="py-3 border-0 wpx-250">{t("customer_asset")}</th>
                                        <th className="py-3 border-0 wpx-300">{t("description")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("priority")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("category")}</th>
                                        {/* ISS-017: ตัดคอลัมน์ "ช่องทาง" และ "วันที่รับ" ออก ใส่ผู้สร้าง/ผู้อนุมัติแทน */}
                                        <th className="py-3 border-0 wpx-180">{t("primary_contact")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("sla_due")}</th>
                                        <th className="py-3 border-0 wpx-180">{t("created_by_col")}</th>
                                        <th className="py-3 border-0 wpx-180">{t("approved_by_col")}</th>
                                        <th className="py-3 border-0 wpx-180 ">{t("status")}</th>
                                        {/* ปุ่ม action ปักไว้ขวาสุด (sticky) ตารางกว้างกว่าจอ เลื่อนแล้วยังกดได้ทันที */}
                                        <th className="py-3 border-0 wpx-120 text-center bg-white" style={STICKY_ACTION_STYLE}>{t("actions")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index} className="border-bottom border-light bg-white">
                                            {/* <td className="px-3 py-2 rounded-start" style={{ borderLeft: `4px solid ${item.borderColor}` }}>
                                                <input type="checkbox" className="form-check-input" />
                                            </td> */}

                                            <td className="text-nowrap">
                                                <a href="#" className="text-primary text-12 fw-bold text-decoration-none" onClick={() => this.openViewModal(item)}>
                                                    {item.wr_number}
                                                </a>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-12 text-dark text-nowrap">{this.getCustomerDisplayName(item.customer)}</div>
                                                <div className="text-secondary text-12">{item.asset ? this.getAssetIdentityLine(item.asset) : ""}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-12 text-dark text-wrap">
                                                    {String(item.problem_description || "").length > 40 ? `${String(item.problem_description || "").slice(0, 40)}...` : item.problem_description || "-"}
                                                </div>
                                                {item.attachments?.length > 0 && (
                                                    <div className="text-secondary text-12 mt-1">
                                                        <span className="text-12 icon me-1">{""}</span> {item.attachments.length}
                                                    </div>
                                                )}
                                            </td>

                                            <td className="text-nowrap">
                                                <span className="badge rounded-pill fw-normal px-2 py-1 text-12" style={this.getPriorityStyle(item.priority?.name_th)}>
                                                    {item.priority?.name_th || ""}
                                                </span>
                                            </td>

                                            <td className="text-nowrap">
                                                <span className={`badge rounded-pill fw-normal px-2 py-1 text-12 ${this.getCategoryClass(item.category?.name_th || "")}`}>
                                                    {item.category?.name_th || ""}
                                                </span>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.contact_name_1 || "-"}</div>
                                                <small className="text-secondary">{item.contact_phone_1 || "-"}</small>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="text-dark text-wrap text-12">
                                                    {item.asset?.customer_warranty_expire_date ? format_date(item.asset.customer_warranty_expire_date, "dd/mm/yyyy", "th") : "-"}
                                                </div>
                                            </td>

                                            {/* ISS-002 + ISS-017: ผู้สร้าง / ผู้อนุมัติ พร้อมเวลาที่ดำเนินการ */}
                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.created_by_user?.full_name || "-"}</div>
                                                <div className="text-secondary text-12">{item.created_at ? format_date(item.created_at, "dd/mm/yyyy hh:mm", "th") : "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.approved_by_user?.full_name || "-"}</div>
                                                <div className="text-secondary text-12">{item.approved_at ? format_date(item.approved_at, "dd/mm/yyyy hh:mm", "th") : "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <span
                                                    className={`badge rounded-pill px-3 py-1 text-12 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(item.status)}`}
                                                    style={item.status === "pending_approval" ? { backgroundColor: "#F3E8FF", color: "#7C3AED", border: "1px solid #C4B5FD" } : undefined}
                                                >
                                                    {item.status.replaceAll("_", " ").toUpperCase()}
                                                </span>
                                            </td>

                                            <td className="rounded-end text-center bg-white" style={STICKY_ACTION_STYLE}>
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                <ActionIconButton
                                                    label={t("view")}
                                                    icon={ACTION_ICONS.view}
                                                    variant="primary"
                                                    onClick={() => this.openDetailModal(item)}
                                                />
                                                {item.status === "pending" ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                                        {can("wr.create") && (
                                                          <ActionIconButton
                                                              label={t("fast_call")}
                                                              icon={ACTION_ICONS.phone}
                                                              variant="warning"
                                                              onClick={() => this.openFastCallModal(item)}
                                                          />
                                                        )}
                                                        {can("wr.update") && (
                                                          <ActionIconButton
                                                              label={t("reject")}
                                                              icon={ACTION_ICONS.close}
                                                              variant="danger"
                                                              onClick={() => this.openRejectModal(item)}
                                                          />
                                                        )}
                                                    </div>
                                                ) : item.status === "pending_approval" ? (
                                                    // ช่างดูใบที่รออนุมัติได้อย่างเดียว (ปุ่มอนุมัติ/ปฏิเสธซ่อน) แต่เปิดดู Fast Call ได้
                                                    this.isTechnicianUser() && !item.fast_call ? null : (
                                                    <div className="d-flex align-items-center gap-2 justify-content-start">
                                                        {this.isTechnicianUser() ? null : (
                                                            <>
                                                                {can("wr.update") && (
                                                                  <ActionIconButton
                                                                      label={t("approve")}
                                                                      icon={ACTION_ICONS.check}
                                                                      variant="success"
                                                                      onClick={() => this.openApproveModal(item)}
                                                                  />
                                                                )}
                                                                {can("wr.update") && (
                                                                  <ActionIconButton
                                                                      label={t("reject")}
                                                                      icon={ACTION_ICONS.close}
                                                                      variant="danger"
                                                                      onClick={() => this.openRejectModal(item)}
                                                                  />
                                                                )}
                                                            </>
                                                        )}
                                                        {item.fast_call ? (
                                                            <ActionIconButton
                                                                label={t("view_fast_call")}
                                                                icon={ACTION_ICONS.phone}
                                                                variant="success"
                                                                onClick={() => this.openViewFastCallModal(item)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                    )
                                                ) : item.status === "approved" ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-start">
                                                        <ActionIconButton
                                                            label={t("view_wo")}
                                                            icon={ACTION_ICONS.view}
                                                            variant="info"
                                                            onClick={() => this.openWorkOrderPage(item)}
                                                        />
                                                        {item.fast_call ? (
                                                            <ActionIconButton
                                                                label={t("view_fast_call")}
                                                                icon={ACTION_ICONS.phone}
                                                                variant="success"
                                                                onClick={() => this.openViewFastCallModal(item)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                ) : item.status === "success" ? (
                                                    <ActionIconButton
                                                        label={t("view_fast_call")}
                                                        icon={ACTION_ICONS.phone}
                                                        variant="success"
                                                        onClick={() => this.openViewFastCallModal(item)}
                                                    />
                                                ) : item.status === "rejected" ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-start">
                                                        <ActionIconButton
                                                            label={t("view_reason")}
                                                            icon={ACTION_ICONS.view}
                                                            variant="secondary"
                                                            onClick={() => this.viewRejectReason(item)}
                                                        />
                                                        {item.fast_call
                                                            ? (
                                                                <ActionIconButton
                                                                    label={t("view_fast_call")}
                                                                    icon={ACTION_ICONS.phone}
                                                                    variant="secondary"
                                                                    onClick={() => this.openViewFastCallModal(item)}
                                                                />
                                                              )
                                                            : null}
                                                    </div>
                                                ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                        <Pagination count={Math.ceil(count / this.state.page_size) || 1} page={this.state.page} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>

                {/* ===================== CREATE WORK REQUEST MODAL ===================== */}
                <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false, ...this.getCreateFormState() })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light">
                    <Modal.Header className="bg-white border-bottom px-4 py-3 d-flex justify-content-between align-items-center" closeButton>
                        <div>
                            <h5 className="fw-bold mb-1 text-dark d-flex align-items-center">
                                <span className="icon me-2 text-secondary">{"\uf0ea"}</span>{" "}
                                {view_mode ? `${t("view")} ${active_request?.wr_number || ""}`.trim() : t("create_work_request")}
                            </h5>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4" style={{ maxHeight: "75vh", overflowY: "auto", backgroundColor: "#F8F9FA" }}>
                      <fieldset disabled={view_mode} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                        {/* Section 1: ข้อมูลลูกค้าและเครื่อง */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2 text-16">{"\uf007"}</span>
                                {t("customer_asset_info")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label text-dark fw-bold text-14">
                                            {t("customer")} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="form-control"
                                            options={activeOptions(data_customer, create_customer_id)}
                                            onChange={(e, i) => {
                                                // ลูกค้าสถานะ hold -> SLA ต้องเป็น Hold เสมอ (backend บังคับซ้ำอีกชั้นตอนบันทึก)
                                                // ยึดสถานะลูกค้าโดยตรง เพราะลูกค้ารายเก่าอาจยังค้าง priority เป็น Medium
                                                const customerPriorityId = this.resolveCustomerPriorityId(i);
                                                const matchedPriority = this.state.data_priorities.find((priority) => priority.uid === customerPriorityId || priority.value === customerPriorityId);

                                                this.setState({
                                                    create_customer_id: e,
                                                    create_contact_name_1: ((i?.contact_first_name || "") + " " + (i?.contact_last_name || "")).trim(),
                                                    create_contact_phone_1: i?.contact_phone || "",
                                                    create_contact_email: i?.contact_email || "",
                                                    create_priority_id: customerPriorityId,
                                                    text_priority_id: this.getPriorityDescription(matchedPriority),
                                                    create_asset_id: "",
                                                    select_asset: null,
                                                    // เปลี่ยนลูกค้า = รายการทรัพย์สินชุดเดิมใช้ไม่ได้แล้ว ล้างทิ้งรอค้นใหม่
                                                    data_asset: [],
                                                    asset_search_keyword: null,
                                                    asset_search_customer_id: null,
                                                });
                                            }}
                                            value={create_customer_id}
                                            placeholder={t("select_customer")}
                                            onSearch={this.searchCustomers}
                                            loading={customer_search_loading}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-dark fw-bold text-14">
                                            {t("asset")} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="form-control"
                                            options={filteredAssetOptions}
                                            onChange={(e, i) => {
                                                this.setState({ create_asset_id: e, select_asset: i });
                                            }}
                                            value={create_asset_id}
                                            placeholder={t("select_asset")}
                                            onSearch={this.searchAssets}
                                            loading={asset_search_loading}
                                            disabled={!create_customer_id}
                                        />
                                    </div>
                                </div>

                                {/* Asset Info Box */}
                                {select_asset && (
                                    <div className="mt-3 bg-primary-light rounded-3 p-3 border border-primary" style={{ backgroundColor: "#EBF3FF", borderColor: "#B3D4FF" }}>
                                        <div className="d-flex align-items-start gap-2 text-14">
                                            <span className="icon text-primary">{"\uf05a"}</span>
                                            <div className="text-primary">
                                                <span className="fw-bold">Asset:</span> {this.getAssetDisplayName(select_asset)} <span className="mx-1">|</span>
                                                <span className="fw-bold">Serial No.:</span> {select_asset?.serial_number} <span className="mx-1">|</span>
                                                <span className="fw-bold">Warranty:</span>{" "}
                                                {this.renderWarrantyBadge(select_asset?.customer_warranty_expire_date)}{" "}
                                                <span className="mx-1">|</span>
                                                <span className="fw-bold">Location:</span> {this.getAssetLocationName(select_asset)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Section 2: ข้อมูลผู้ติดต่อ */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2 text-16">{"\uf095"}</span>
                                {t("contact_info")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                <div className="row g-3">
                                    <div className="col-md-8">
                                        <label className="form-label text-dark fw-bold text-14">
                                            {t("primary_contact")}{" "}
                                            <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("enter_primary_contact_name")}
                                            value={create_contact_name_1}
                                            onChange={(e) => this.setState({ create_contact_name_1: e.target.value })}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-white d-none d-md-block">&nbsp;</label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("enter_primary_contact_phone")}
                                            value={create_contact_phone_1}
                                            onChange={(e) => this.setState({ create_contact_phone_1: e.target.value })}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-8 mt-3">
                                        <label className="form-label text-dark fw-bold text-14">{t("secondary_contact_optional")}</label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("enter_secondary_contact_name")}
                                            value={create_contact_name_2}
                                            onChange={(e) => this.setState({ create_contact_name_2: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-4 mt-md-3">
                                        <label className="form-label text-white d-none d-md-block">&nbsp;</label>
                                        <input
                                            type="text"
                                            className="form-control py-2 "
                                            placeholder={t("phone_number")}
                                            maxLength={10}
                                            value={create_contact_phone_2}
                                            onChange={(e) => {
                                                if (!float(e.target.value)) return;
                                                this.setState({ create_contact_phone_2: e.target.value });
                                            }}
                                        />
                                    </div>

                                    <div className="col-12 mt-3">
                                        <label className="form-label text-dark fw-bold text-14">{t("customer_email")}</label>
                                        <input
                                            type="email"
                                            className="form-control py-2  text-secondary"
                                            placeholder={t("customer_email")}
                                            value={create_contact_email}
                                            onChange={(e) => this.setState({ create_contact_email: e.target.value })}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 3: รายละเอียดปัญหา */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2">{"\uf0ad"}</span>
                                {t("problem_detail")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">
                                            {t("req_category")}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            sort={false}
                                            className="form-control"
                                            placeholder={t("select_req_category")}
                                            options={activeOptions(data_categories, create_category_id)}
                                            onChange={(e, i) => {
                                                this.setState({ create_category_id: e, create_service_type_id: i?.service_type_default?.uid || this.getDefaultServiceTypeId() });
                                            }}
                                            value={create_category_id}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">
                                            {t("service_type")}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            sort={false}
                                            className="form-control"
                                            placeholder={t("select_service_type")}
                                            options={activeOptions(data_service_types, create_service_type_id)}
                                            onChange={(e, i) => {
                                                this.setState({ create_service_type_id: e });
                                            }}
                                            value={create_service_type_id}
                                        />
                                    </div>
                                    <div className="col-12 mt-3">
                                        <label className="form-label fw-bold">
                                            {t("problem_description")} <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            className="form-control "
                                            rows="3"
                                            placeholder={t("describe_problem_detail")}
                                            value={create_problem_desc}
                                            onChange={(e) => this.setState({ create_problem_desc: e.target.value })}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 4: ความสำคัญ */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3">
                                <span className="icon me-2 text-warning">{"\uf0e7"}</span> {t("priority")}
                                <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
                                <span className="text-danger"> *</span>
                            </h6>
                            <div className="bg-white rounded-3 p-3 border">
                                <div className="row g-3">
                                    <div className="col-12 col-lg-6">
                                        <Select sort={false}
                                            className="form-control"
                                            placeholder={t("select_priority")}
                                            options={activeOptions(data_priorities, create_priority_id)}
                                            onChange={(e, i) => {
                                                this.setState({
                                                    create_priority_id: e,
                                                    text_priority_id: this.getPriorityDescription(i),
                                                });
                                            }}
                                            value={create_priority_id}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <input type="text" className="form-control" value={text_priority_id} placeholder={t("priority")} disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 5: ไฟล์แนบ (DRAG & DROP) */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                <span className="icon me-2 text-16">{"\uf0c6"}</span> {t("attachment_files")}
                            </h6>
                            <div className="bg-white rounded-3 p-3 border ">
                                {/* Images Dropzone */}
                                <label className="form-label text-dark fw-bold text-14 mb-2">
                                    {t("images")} <span className="text-secondary fw-normal">({images.length}/{IMAGE_RULE.maxFiles})</span>
                                </label>
                                {!view_mode && (
                                <div
                                    className="border rounded-3 p-4 mb-3 text-center pointer"
                                    style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                                    onDragOver={this.handleDragOver}
                                    onDrop={this.handleImageDrop}
                                    onClick={() => document.getElementById("img-upload").click()}
                                >
                                    <input
                                        type="file"
                                        id="img-upload"
                                        multiple
                                        accept="image/*"
                                        hidden
                                        onChange={(e) => {
                                            const files = Array.from(e.target.files || []);
                                            e.target.value = "";
                                            this.addFiles(files, "image");
                                        }}
                                    />
                                    <span className="icon text-30 text-success mb-2 d-block">{"\uf03e"}</span>
                                    <div className="fw-bold text-dark text-14">{t("click_or_drag_image_here")}</div>
                                    <div className="text-12 text-secondary mt-1">
                                        {formatText(t("upload_hint_images"), { count: IMAGE_RULE.maxFiles, size: toMB(IMAGE_RULE.maxSize) })}
                                    </div>
                                </div>
                                )}

                                {/* Preview Images */}
                                <div className="d-flex flex-wrap gap-2 mb-4">
                                    {images.map((img, i) => (
                                        <div key={i} className="border rounded-3 p-2 text-center position-relative bg-light wpx-100">
                                            {!view_mode && (
                                            <div
                                                className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                                style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                                onClick={() => this.removeImage(i)}
                                            >
                                                <span className="icon text-10">{"\uf00d"}</span>
                                            </div>
                                            )}
                                            <a href={img.url} target="_blank" rel="noopener noreferrer" download={img.name || undefined}>
                                                <img
                                                    src={img.url}
                                                    alt={img.name}
                                                    className="rounded-2 mb-1"
                                                    style={{ width: "100%", height: "70px", objectFit: "cover" }}
                                                />
                                            </a>
                                            <div className="text-10 text-secondary text-truncate" title={img.name}>{img.name}</div>
                                            <div className="text-10 text-secondary">{formatFileSize(img.size ?? img.file_size)}</div>
                                        </div>
                                    ))}
                                </div>

                                {/* Videos Dropzone */}
                                <label className="form-label text-dark fw-bold text-14 mb-2">
                                    {t("videos")} <span className="text-secondary fw-normal">({videos.length}/{VIDEO_RULE.maxFiles})</span>
                                </label>
                                {!view_mode && (
                                <div
                                    className="border rounded-3 p-4 mb-3 text-center pointer"
                                    style={{ borderStyle: "dashed", borderColor: "#fd7e14", backgroundColor: "#fff8f3" }}
                                    onDragOver={this.handleDragOver}
                                    onDrop={this.handleVideoDrop}
                                    onClick={() => document.getElementById("vid-upload").click()}
                                >
                                    <input
                                        type="file"
                                        id="vid-upload"
                                        multiple
                                        accept="video/mp4,video/quicktime"
                                        hidden
                                        onChange={(e) => {
                                            const files = Array.from(e.target.files || []);
                                            e.target.value = "";
                                            this.addFiles(files, "video");
                                        }}
                                    />
                                    <span className="icon text-30 text-dark mb-2 d-block">{"\uf03d"}</span>
                                    <div className="fw-bold text-dark text-14">{t("click_or_drag_video_here")}</div>
                                    <div className="text-12 text-secondary mt-1">
                                        {formatText(t("upload_hint_videos"), { count: VIDEO_RULE.maxFiles, size: toMB(VIDEO_RULE.maxSize) })}
                                    </div>
                                </div>
                                )}

                                {/* Preview Videos */}
                                <div className="d-flex flex-wrap gap-3 mb-3">
                                    {videos.map((vid, i) => (
                                        <div key={i} className="border rounded-3 p-2 position-relative bg-light" style={{ width: "200px" }}>
                                            {!view_mode && (
                                            <div
                                                className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                                style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                                onClick={() => this.removeVideo(i)}
                                            >
                                                <span className="icon text-10">{"\uf00d"}</span>
                                            </div>
                                            )}
                                            <video
                                                src={vid.url}
                                                controls
                                                className="rounded-2 mb-1 w-100 bg-dark"
                                                style={{ height: "110px", objectFit: "contain" }}
                                            />
                                            <div className="text-10 text-secondary text-truncate fw-bold" title={vid.name}>{vid.name}</div>
                                            <div className="text-10 text-secondary">{formatFileSize(vid.size ?? vid.file_size)}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="mb-2">
                            <h6 className="fw-bold text-secondary mb-3">
                                <span className="icon me-2">{"\uf044"}</span> {t("admin_internal_note")}
                            </h6>
                            <textarea
                                className="form-control  text-14"
                                rows="3"
                                placeholder={t("internal_notes")}
                                value={create_internal_note}
                                onChange={(e) => this.setState({ create_internal_note: e.target.value })}
                            ></textarea>
                        </div>
                      </fieldset>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_create: false, ...this.getCreateFormState() })}>
                            {view_mode ? t("close") : t("cancel")}
                        </button>
                        {!view_mode && (
                            <button className="btn btn-primary px-4 py-2" onClick={this.CreateUpdate}>
                                + {t("create_request")}
                            </button>
                        )}
                    </Modal.Footer>
                </Modal>

                {/* ===================== Fast Call Modal ===================== */}
                <Modal
                    size="lg"
                    show={modal_fast_call}
                    onHide={() => this.setState({ modal_fast_call: false, fast_call_view_mode: false, ...this.getFastCallFormState() })}
                    centered
                    contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
                >
                    <Modal.Header className="bg-white p-4 border-bottom" closeButton>
                        <div className="w-100">
                            <h3 className="fw-bold mb-1 text-dark d-flex align-items-center">
                                <span className="icon me-2 text-dark">{"\uf095"}</span>
                                {fast_call_view_mode ? t("view_fast_call_info") : t("record_fast_call_result")}
                            </h3>
                            <div className="text-secondary text-14">
                                {active_request?.wr_number || "-"} • {this.getCustomerDisplayName(active_request?.customer)}
                            </div>
                            {/* Workflow Steps */}
                            <div className="d-flex w-100 overflow-auto mt-3" style={{ gap: "2px" }}>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 rounded-start d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span>
                                    <span className="">{t("wr_created")}</span>
                                </div>
                                <div
                                    className={`${
                                        active_request?.fast_call ? "bg-success text-white" : "bg-warning text-white border"
                                    } px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    {active_request?.fast_call ? <span className="icon me-1">{"\uf00c"}</span> : null}
                                    <span className="">{t("call_result_recorded")}</span>
                                </div>
                                <div
                                    className={`${
                                        active_request?.fast_call && active_request.status !== "rejected" ? "bg-success text-white" : "bg-light text-secondary border"
                                    } px-3 py-2 fw-bold text-12 rounded-end d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    {active_request?.fast_call && active_request?.fast_call?.status === "success" ? <span className="icon me-1">{"\uf00c"}</span> : null}
                                    <span className="">
                                        {active_request?.fast_call && active_request?.fast_call?.status === "success"
                                            ? t("close_job")
                                            : active_request?.fast_call && active_request?.fast_call?.status === "pending_approval" && active_request.status !== "rejected"
                                            ? t("issue_wo")
                                            : t("close_job_or_issue_wo")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 py-4 bg-white" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                        <div className="rounded-3 border px-4 py-3 mb-4" style={{ backgroundColor: "#EFF6FF", borderColor: "#BFDBFE" }}>
                            <div className="text-primary fw-bold text-16">🔧 {active_request?.problem_description || "-"}</div>
                        </div>

                        <div className="mb-3 pb-2 border-bottom">
                            <div className="fw-bold text-secondary text-16">
                                <span className="icon me-2">{"\uf095"}</span>
                                {t("call_details")}
                            </div>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">
                                    {t("calling_technician")} <span className="text-danger">*</span>
                                </label>
                                <Select
                                    className="form-control"
                                    options={fastCallTechnicianOptions}
                                    value={fast_call_technician}
                                    placeholder={t("select_calling_technician")}
                                    onChange={(e) => this.setState({ fast_call_technician: e })}
                                    disabled={fast_call_view_mode || this.isTechnicianUser()}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">
                                    {t("call_datetime")} <span className="text-danger">*</span>
                                </label>
                                <div className="d-flex gap-2">
                                    <DatePicker
                                        type="th"
                                        className="form-control py-2"
                                        value={fast_call_date}
                                        onChange={(val) => this.setState({ fast_call_date: val })}
                                        disabled={fast_call_view_mode}
                                    />
                                    <input
                                        type="time"
                                        className="form-control py-2"
                                        style={{ maxWidth: "120px" }}
                                        value={fast_call_time}
                                        onChange={(e) => this.setState({ fast_call_time: e.target.value })}
                                        disabled={fast_call_view_mode}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">{t("call_duration_minutes")}</label>
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control py-2"
                                        style={{ paddingRight: "52px" }}
                                        placeholder={t("eg_15_minutes")}
                                        value={fast_call_duration}
                                        onChange={(e) => this.setState({ fast_call_duration: e.target.value.replace(/\D/g, "") })}
                                        disabled={fast_call_view_mode}
                                    />
                                    <span className="position-absolute top-50 translate-middle-y text-secondary small" style={{ right: "12px", pointerEvents: "none" }}>
                                        {t("call_minutes_unit")}
                                    </span>
                                </div>
                                {(() => {
                                    const end = this.getFastCallEnd();
                                    if (!end) {
                                        return fast_call_view_mode ? null : (
                                            <div className="mt-1 small text-secondary" data-testid="fast-call-end">
                                                {"⏱ "}
                                                {t("call_end_need_minutes")}
                                            </div>
                                        );
                                    }
                                    return (
                                        <div className="mt-1 small text-secondary d-flex align-items-center flex-wrap gap-1" data-testid="fast-call-end">
                                            <span>{"⏱ "}{t("call_end_time_label")}</span>
                                            <b className="text-primary">
                                                {end.time}
                                                {t("call_end_time_suffix") ? ` ${t("call_end_time_suffix")}` : ""}
                                            </b>
                                            {end.nextDay ? (
                                                <span className="badge bg-warning-subtle text-warning-emphasis">
                                                    {t("call_end_next_day")} ({end.date})
                                                </span>
                                            ) : null}
                                            <span>{`(${end.start}\u2013${end.time})`}</span>
                                        </div>
                                    );
                                })()}
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">{t("call_channel_label")}</label>
                                <select className="form-select py-2" value={fast_call_channel} onChange={(e) => this.setState({ fast_call_channel: e.target.value })} disabled={fast_call_view_mode}>
                                    <option value="โทรศัพท์ตรง">{t("direct_phone_call")}</option>
                                    <option value="Line Call">Line Call</option>
                                    <option value="Video Call">Video Call</option>
                                </select>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-bold">{t("customer_reported_symptom_summary")}</label>
                            <textarea
                                className="form-control py-3"
                                rows="2"
                                placeholder={t("call_detail_placeholder")}
                                value={fast_call_symptom}
                                onChange={(e) => this.setState({ fast_call_symptom: e.target.value })}
                                disabled={fast_call_view_mode}
                            ></textarea>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-bold">
                                {t("recommended_solution_label")} <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control py-3"
                                rows="4"
                                maxLength={500}
                                placeholder={t("solution_guidance_placeholder")}
                                value={fast_call_guidance}
                                onChange={(e) => this.setState({ fast_call_guidance: e.target.value })}
                                disabled={fast_call_view_mode}
                            ></textarea>
                            <div className="text-muted text-12 mt-1 text-end">{(fast_call_guidance || "").length} / 500</div>
                        </div>

                        <div className="mb-3 pb-2 border-bottom">
                            <div className="fw-bold text-secondary text-16">{t("resolution_result_select_one")}</div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <div
                                    className={`rounded-4 border p-4 text-center pointer h-100 transition-hover ${fast_call_result === "closed" ? "shadow-sm" : ""}`}
                                    style={{
                                        borderWidth: fast_call_result === "closed" ? "3px" : "1px",
                                        borderColor: fast_call_result === "closed" ? "#059669" : "#D1FAE5",
                                        backgroundColor: fast_call_result === "closed" ? "#BBF7D0" : "#F0FDF4",
                                        boxShadow: fast_call_result === "closed" ? "0 0 0 5px rgba(16, 185, 129, 0.28), 0 14px 30px rgba(5, 150, 105, 0.18)" : "none",
                                        transform: fast_call_result === "closed" ? "translateY(-2px)" : "none",
                                        position: "relative",
                                    }}
                                    onClick={() => !fast_call_view_mode && this.setState({ fast_call_result: "closed" })}
                                >
                                    {fast_call_result === "closed" && (
                                        <div
                                            className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center text-white fw-bold"
                                            style={{
                                                width: "36px",
                                                height: "36px",
                                                backgroundColor: "#059669",
                                                borderBottomLeftRadius: "16px",
                                                borderTopRightRadius: "14px",
                                            }}
                                        >
                                            ✓
                                        </div>
                                    )}
                                    <div className="text-success text-40 mb-2">{fast_call_result === "closed" ? "✅" : "☑️"}</div>
                                    <div className="fw-bold text-success text-20 mb-2">{t("resolved_close_job")}</div>
                                    <div className="text-secondary">
                                        {t("customer_confirmed_normal_operation")}
                                        <br />
                                        {t("system_will_close_wo_as_phone_fix")}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div
                                    className={`rounded-4 border p-4 text-center pointer h-100 transition-hover ${fast_call_result === "visit" ? "shadow-sm" : ""}`}
                                    style={{
                                        borderWidth: fast_call_result === "visit" ? "3px" : "1px",
                                        borderColor: fast_call_result === "visit" ? "#2563EB" : "#BFDBFE",
                                        backgroundColor: fast_call_result === "visit" ? "#BFDBFE" : "#EFF6FF",
                                        boxShadow: fast_call_result === "visit" ? "0 0 0 5px rgba(59, 130, 246, 0.28), 0 14px 30px rgba(37, 99, 235, 0.18)" : "none",
                                        transform: fast_call_result === "visit" ? "translateY(-2px)" : "none",
                                        position: "relative",
                                    }}
                                    onClick={() => !fast_call_view_mode && this.setState({ fast_call_result: "visit" })}
                                >
                                    {fast_call_result === "visit" && (
                                        <div
                                            className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center text-white fw-bold"
                                            style={{
                                                width: "36px",
                                                height: "36px",
                                                backgroundColor: "#2563EB",
                                                borderBottomLeftRadius: "16px",
                                                borderTopRightRadius: "14px",
                                            }}
                                        >
                                            ✓
                                        </div>
                                    )}
                                    <div className="text-primary text-40 mb-2">{fast_call_result === "visit" ? "🔧" : "🛠️"}</div>
                                    <div className="fw-bold text-primary text-20 mb-2">{t("requires_onsite_visit")}</div>
                                    <div className="text-secondary">
                                        {t("cannot_resolve_by_phone")}
                                        <br />
                                        {t("system_will_create_onsite_wo_after_approval")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end align-items-center">
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-white border px-4 py-2 rounded-3 fw-bold"
                                onClick={() => this.setState({ modal_fast_call: false, fast_call_view_mode: false, ...this.getFastCallFormState() })}
                            >
                                {fast_call_view_mode ? t("close") : t("cancel")}
                            </button>
                            {!fast_call_view_mode && (
                                <button
                                    className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white"
                                    style={{
                                        backgroundColor: "#3B82F6",
                                        borderColor: "#3B82F6",
                                        opacity: fast_call_result ? 1 : 0.55,
                                        cursor: fast_call_result ? "pointer" : "not-allowed",
                                    }}
                                    onClick={this.submitFastCall}
                                    disabled={!fast_call_result}
                                >
                                    {!fast_call_result ? t("save_result") : fast_call_result === "closed" ? t("save_and_close_job") : t("save_result")}
                                </button>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* ===================== APPROVE MODAL ===================== */}
                <Modal size="md" show={modal_approve} onHide={() => this.setState({ modal_approve: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                    <Modal.Header className="bg-white border-bottom px-4 py-3" closeButton>
                        <div className="d-flex align-items-center">
                            <div className="wpx-25 hpx-25 rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-2">
                                <span className="icon text-12">{"\uf00c"}</span>
                            </div>
                            <h5 className="fw-bold mb-0 text-dark">{t("approve_work_request")}</h5>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4 bg-white">
                        <div className="bg-light rounded-3 p-3 mb-4 d-flex justify-content-between align-items-start border ">
                            <div>
                                <div className="text-secondary text-12 mb-1">{t("request_id")}</div>
                                <h5 className="fw-bold text-dark mb-3">{active_request?.wr_number || ""}</h5>
                                <div className="text-secondary text-14">
                                    {t("customer_label")} <span className="text-dark fw-bold">{this.getCustomerDisplayName(active_request?.customer)}</span>
                                </div>
                                <div className="text-secondary text-14">
                                    {t("asset_label")} <span className="text-dark">{active_request?.asset?.part_name || ""}</span>
                                </div>
                                {/* ISS-002: ผู้ดำเนินการ (ผู้สร้าง/ผู้อนุมัติ) พร้อมเวลาที่ดำเนินการ */}
                                <div className="text-secondary text-14 mt-2">
                                    {t("created_by_label")}{" "}
                                    <span className="text-dark fw-bold">{active_request?.created_by_user?.full_name || "-"}</span>
                                    {active_request?.created_at ? ` (${format_date(active_request.created_at, "dd/mm/yyyy hh:mm", "th")})` : ""}
                                </div>
                                {active_request?.approved_by_user && (
                                    <div className="text-secondary text-14">
                                        {t("approved_by_label")}{" "}
                                        <span className="text-dark fw-bold">{active_request.approved_by_user.full_name}</span>
                                        {active_request?.approved_at ? ` (${format_date(active_request.approved_at, "dd/mm/yyyy hh:mm", "th")})` : ""}
                                    </div>
                                )}
                            </div>
                            <span className="badge rounded-pill fw-bold px-3 py-1 text-12" style={this.getPriorityStyle(active_request?.priority?.name_th || "")}>
                                {active_request?.priority?.name_th || ""}
                            </span>
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-14 text-dark fw-bold">{t("work_order_type")}</label>
                            <Select sort={false} className="form-control" placeholder={t("select_req_category")} options={data_categories} value={create_category_id} disabled />
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold">{t("priority")}</label>
                                <Select sort={false} className="form-control" placeholder={t("select_priority")} options={data_priorities} value={create_priority_id} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold">{t("sla_template")}</label>
                                <input type="text" className="form-control" value={text_priority_id} disabled />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-14 text-dark fw-bold">{t("assign_technicians_optional")}</label>

                            <div className="border border-purple rounded-3 overflow-hidden">
                                <div className="bg-purple-light p-2 d-flex align-items-center border-bottom border-purple">
                                    <div className="wpx-25 hpx-25 rounded-circle bg-purple text-white d-flex align-items-center justify-content-center me-2">
                                        <span className="icon text-12">{"\uf040"}</span>
                                    </div>
                                    <span className="text-purple fw-bold me-2">{t("ai_recommended_technicians")}</span>
                                    <span className="badge bg-purple-light text-purple rounded-pill fw-normal text-10">{t("based_on_job_requirements")}</span>
                                </div>

                                <div className="p-3 bg-white">
                                    <div className="d-flex flex-column gap-3">
                                        {technicians.map((tech, idx) => (
                                            <div key={idx} className={`border rounded-3 p-3 position-relative ${tech.bestMatch ? "border-success bg-success-light-light" : " bg-white shadow-sm"}`}>
                                                {tech.bestMatch && (
                                                    <div className="position-absolute top-0 end-0 bg-success text-white px-2 py-1 text-10 fw-bold" style={{ borderBottomLeftRadius: "8px" }}>
                                                        <span className="icon me-1">{"\uf521"}</span> {t("best_match")}
                                                    </div>
                                                )}

                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-16 me-3"
                                                            style={{ backgroundColor: tech.bg }}
                                                        >
                                                            {tech.initials}
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-dark text-16">{tech.name}</div>
                                                            <div className="text-secondary text-12 d-flex align-items-center">
                                                                <div className={`wpx-8 hpx-8 rounded-circle bg-${tech.statusColor} me-1`}></div>
                                                                <span className={`text-${tech.statusColor} fw-bold me-2`}>{tech.status}</span>
                                                                <span className="icon text-10 me-1">{"\uf041"}</span> {tech.distance}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className={`btn btn-sm px-3 rounded-pill fw-bold ${tech.bestMatch ? "btn-success" : "btn-outline-primary bg-white"}`}>+ {t("add")}</button>
                                                </div>

                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                    {tech.tags.map((tag, tIdx) => (
                                                        <span key={tIdx} className={`badge bg-${tag.color}-light text-${tag.color} rounded-2 px-2 py-1 text-10 border border-${tag.color}`}>
                                                            <span className="icon me-1">{tag.icon}</span> {tag.text}
                                                        </span>
                                                    ))}
                                                </div>

                                                {tech.hint && (
                                                    <div className={`text-${tech.hintColor} text-12 fst-italic mt-2`}>
                                                        <span className="icon me-1">{tech.hintIcon}</span> {tech.hint}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="text-center mt-3 pt-2 border-top">
                                        <a href="#" className="text-purple text-decoration-none fw-bold text-14">
                                            <span className="icon me-1">{"\uf0ca"}</span> {t("view_all_available_technicians")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-secondary text-14">
                            {t("selected_technicians")} <span className="fst-italic">{t("none")}</span>
                        </div>

                        <div className="mt-4 pt-4 border-top">
                            <a href="#" className="text-secondary text-decoration-none text-14 d-block mb-3">
                                <span className="icon me-1">{"\uf054"}</span> {t("select_manually")}
                            </a>

                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("required_parts")}</label>
                            <div className="border rounded-3 p-3 mb-4">
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" defaultChecked id="part1" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part1">
                                        Compressor Motor 2HP (Qty: 1)
                                    </label>
                                </div>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" defaultChecked id="part2" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part2">
                                        Refrigerant R-410A (Qty: 2kg)
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="part3" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part3">
                                        Filter Drier (Qty: 1)
                                    </label>
                                </div>
                            </div>

                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("internal_notes")}</label>
                            <textarea className="form-control" rows="3" placeholder={t("add_notes_placeholder")}></textarea>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_approve: false })}>
                            {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold text-white shadow-sm" style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}>
                            <span className="icon me-2">{"\uf00c"}</span> {t("create_work_order")}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* ===================== REJECT MODAL ===================== */}
                <Modal size="md" show={modal_reject} onHide={() => this.setState({ modal_reject: false, reject_view_mode: false })} centered>
                    <Modal.Header className="bg-white px-4 pt-4 pb-0 border-0" closeButton>
                        <div className="d-flex align-items-center">
                            <span className="icon text-dark me-2 text-20 fw-bold">{"\uf00d"}</span>
                            <h4 className="fw-bold mb-0 text-dark">{reject_view_mode ? `${t("view")} ${t("reject_reason")}` : t("reject_work_request")}</h4>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 pb-2 pt-3 bg-white">
                        <div className="mb-2">
                            <label className="form-label text-dark fw-bold text-16">
                                {t("reject_reason")} {!reject_view_mode && <span className="text-danger">*</span>}
                            </label>
                            <Select
                                sort={false}
                                className="form-control"
                                placeholder={t("select_reject_reason")}
                                onChange={(e, i) => {
                                    this.setState({ reject_reason_id: e });
                                }}
                                value={reject_reason_id}
                                options={activeOptions(data_reject_reasons, reject_reason_id)}
                                disabled={reject_view_mode}
                            />
                        </div>

                        <div className="mb-3 mt-3">
                            <label className="form-label text-dark fw-bold text-16">{t("additional_note")}</label>
                            <textarea
                                className="form-control py-2 "
                                rows="4"
                                placeholder={t("additional_notes")}
                                value={reject_note}
                                onChange={(e) => this.setState({ reject_note: e.target.value })}
                                disabled={reject_view_mode}
                            ></textarea>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-0 px-4 pb-4 pt-2 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_reject: false, reject_view_mode: false })}>
                            {reject_view_mode ? t("close") : t("cancel")}
                        </button>
                        {!reject_view_mode && (
                            <button className="btn btn-danger px-4 py-2" onClick={this.SubmitReject}>
                                {t("confirm_reject")}
                            </button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
